import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Inicio',
  href: '#inicio'
}, {
  name: 'Servicios',
  href: '#servicios'
}, {
  name: 'Galería',
  href: '#galeria'
}, {
  name: 'Sobre mí',
  href: '#sobre-mi'
}, {
  name: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 80; // header height
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <header className={`sticky top-0 left-0 right-0 z-40 transition-all duration-300 bg-brand-cream/95 backdrop-blur-md shadow-sm py-4`} data-id="element-149">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-150">
        {/* Logo */}
        <a href="#inicio" onClick={e => scrollTo(e, '#inicio')} className={`font-serif text-2xl font-medium tracking-tight transition-colors duration-300 text-brand-mocha`} data-id="element-151">
          CF Studio
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-152">
          <ul className="flex items-center gap-8" data-id="element-153">
            {navLinks.map(link => <li key={link.name} data-id="element-154">
                <a href={link.href} onClick={e => scrollTo(e, link.href)} className={`text-sm font-medium transition-colors hover:text-brand-rose text-brand-mocha/80`} data-id="element-155">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 bg-brand-rose text-white hover:bg-brand-rose/90 shadow-sm`} data-id="element-156">
            Agendar Turno
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`md:hidden p-2 -mr-2 transition-colors text-brand-mocha`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-157">
          {isMobileMenuOpen ? <X size={24} data-id="element-158" /> : <Menu size={24} data-id="element-159" />}
        </button>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-160">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="absolute top-full left-0 right-0 bg-brand-cream shadow-lg border-t border-brand-mocha/10 md:hidden" data-id="element-161">
            <nav className="flex flex-col p-6 gap-4" data-id="element-162">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollTo(e, link.href)} className="text-brand-mocha text-lg py-2 border-b border-brand-mocha/5" data-id="element-163">
                  {link.name}
                </a>)}
              <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className="mt-4 bg-brand-rose text-white text-center py-3 rounded-full font-medium" data-id="element-164">
                Agendar Turno
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}